import React from 'react';
import {
  Box,
  HeadingText,
  Image,
  StackLayout,
  ParagraphText,
  Card,
  TextAction,
  useClickableCard,
} from '@leagueplatform/genesis-core';
import {
  ChallengeIcon,
  ICON_TYPES,
} from '#components/challenge-icon/challenge-icon.component.tsx';
import { useChallengesAnalytics } from '#hooks/use-challenges-analytics.hook.tsx';
import { EVENT_NAME, PRODUCT_AREA } from '@leagueplatform/analytics';
import { TLP_SCREEN_NAMES } from '#constants/analytics.constants.tsx';

export interface TeamsOptionProps {
  image: string;
  heading: string;
  description?: string;
  setChoice(): void;
}

export const TeamsOption = ({
  image,
  heading,
  description,
  setChoice,
}: TeamsOptionProps): JSX.Element => {
  const { trackChallengesAnalyticsEvent } = useChallengesAnalytics();
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } =
    useClickableCard();

  const handleAnalyticsClick = (detail: string) =>
    trackChallengesAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
      product_area: PRODUCT_AREA.JOURNEY,
      screen_name: TLP_SCREEN_NAMES.JOIN_OR_CREATE_TEAM,
      detail,
    });
  const handleClick = () => {
    handleAnalyticsClick(heading.toLowerCase());
    setChoice();
  };
  return (
    <Card.Flat
      css={{
        borderWidth: '$thin',
        borderRadius: '$medium',
        borderColor: '$onSurfaceBorderSubdued',
        backgroundColor: '$tertiaryBackgroundDefault',
      }}
    >
      <Card.ClickArea
        ref={clickAreaRef}
        onCardMouseUp={onCardMouseUp}
        onCardMouseDown={onCardMouseDown}
      >
        <StackLayout
          orientation="horizontal"
          verticalAlignment="center"
          spacing="$one"
          css={{ padding: '$one' }}
        >
          <Image src={image} alt="" aria-hidden height={56} width={56} />
          <Box>
            <TextAction
              as="button"
              onClick={handleClick}
              ref={primaryActionRef}
            >
              <HeadingText level="2" size="md">
                {heading}
              </HeadingText>
            </TextAction>
            {description && (
              <ParagraphText size="sm" css={{ marginTop: '$half' }}>
                {description}
              </ParagraphText>
            )}
          </Box>
          <Box
            css={{
              transform: 'rotate(180deg)',
              marginInlineStart: 'auto',
            }}
          >
            <ChallengeIcon iconType={ICON_TYPES.CHEVRON} />
          </Box>
        </StackLayout>
      </Card.ClickArea>
    </Card.Flat>
  );
};
